import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';

export interface IRingtone {
  name: string;
  url: string;
}

const fileApi = {
  getRingtones() {
    return axiosClient.get<IBaseResponse<IRingtone[]>>('files/ringtone');
  },
};

export default fileApi;
